var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "create_dialog",
          attrs: {
            "before-close": _vm.handleClose,
            visible: _vm.isOpen,
            "show-close": true,
            fullscreen: true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpen = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "title_dialog" }, [
                    _c("span", [_vm._v("Sửa phiếu khảo sát")]),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "body_dialog" },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 30 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c(
                      "div",
                      { staticClass: "section_setting" },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 6 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c(
                                "div",
                                {
                                  class: [
                                    "wrap_setting border_element_setting gutter_row",
                                    _vm.isValid.dateTime ? "border_error" : "",
                                  ],
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class: !_vm.isAnswer
                                        ? "container_setting active_click"
                                        : "container_setting disable_click",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: !_vm.isAnswer
                                            ? "label_settings"
                                            : "disable_click",
                                          on: {
                                            click: function ($event) {
                                              !_vm.isAnswer &&
                                                _vm.handleChangeIsApplyTime
                                            },
                                          },
                                        },
                                        [_vm._v("Thời gian áp dụng:")]
                                      ),
                                      _c("el-switch", {
                                        attrs: { disabled: _vm.isAnswer },
                                        model: {
                                          value: _vm.isApplyTime,
                                          callback: function ($$v) {
                                            _vm.isApplyTime = $$v
                                          },
                                          expression: "isApplyTime",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.isApplyTime
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px",
                                            "padding-top": "10px",
                                            "border-top": "1px solid #DCDFE6",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              attrs: {
                                                type: "flex",
                                                gutter: 20,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "label_time",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Ngày bắt đầu: "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("el-date-picker", {
                                                        staticClass:
                                                          "picker_time_apply",
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày bắt đầu",
                                                          format: "dd/MM/yyyy",
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          disabled:
                                                            _vm.isAnswer,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.defaultDataForm
                                                              .fistDay,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.defaultDataForm,
                                                              "fistDay",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "defaultDataForm.fistDay",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "label_time",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Ngày kết thúc: "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("el-date-picker", {
                                                        staticClass:
                                                          "picker_time_apply",
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "Chọn ngày kết thúc",
                                                          "picker-options":
                                                            _vm.pickerLastDayOptions,
                                                          "value-format":
                                                            "yyyy-MM-dd",
                                                          format: "dd/MM/yyyy",
                                                          disabled:
                                                            _vm.disabledLastDay,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.defaultDataForm
                                                              .lastDay,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.defaultDataForm,
                                                              "lastDay",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "defaultDataForm.lastDay",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm.isValid.dateTime
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "message_error",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      *Vui lòng chọn thời gian\n                    "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wrap_setting border_element_setting gutter_row",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "container_setting" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "label_settings" },
                                        [_vm._v("Phạm vi:")]
                                      ),
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "selected_scope",
                                          attrs: {
                                            placeholder: "Chọn phạm vi",
                                          },
                                          on: {
                                            change: _vm.handleChangeScopeApply,
                                          },
                                          model: {
                                            value: _vm.scopeForm,
                                            callback: function ($$v) {
                                              _vm.scopeForm = $$v
                                            },
                                            expression: "scopeForm",
                                          },
                                        },
                                        _vm._l(
                                          _vm.listScopeApply,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "margin-top": "10px",
                                        "padding-top": "10px",
                                        "border-top": "1px solid #DCDFE6",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { type: "flex", gutter: 4 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    "justify-content": "end",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticClass:
                                                        "button_choice",
                                                      attrs: {
                                                        type: _vm
                                                          .isShowButtonScope
                                                          .class
                                                          ? "primary"
                                                          : "info",
                                                        size: "medium",
                                                        plain: true,
                                                        disabled:
                                                          !_vm.isShowButtonScope
                                                            .class,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.handleShowApplyKid,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            Lớp\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: "12" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      staticClass:
                                                        "button_choice",
                                                      attrs: {
                                                        type: _vm
                                                          .isShowButtonScope
                                                          .employee
                                                          ? "primary"
                                                          : "info",
                                                        size: "medium",
                                                        plain: true,
                                                        disabled:
                                                          !_vm.isShowButtonScope
                                                            .employee,
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.handleShowApplyEmployee,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            Nhân sự\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "container_apply" },
                                    [
                                      _c(
                                        "el-row",
                                        { attrs: { type: "flex", gutter: 4 } },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: !_vm.isShowButtonScope
                                                    .class
                                                    ? "element_apply disabled_apply"
                                                    : "element_apply",
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Danh sách học sinh"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "answer_apply",
                                                    },
                                                    _vm._l(
                                                      _vm.applyForm.kids,
                                                      function (kid, index) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: index,
                                                            staticStyle: {
                                                              "font-size":
                                                                "12px",
                                                              "margin-bottom":
                                                                "8px",
                                                              display: "flex",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-right":
                                                                    "4px",
                                                                },
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "el-icon-circle-check",
                                                                  staticStyle: {
                                                                    color:
                                                                      "#67C23A",
                                                                  },
                                                                }),
                                                              ]
                                                            ),
                                                            _c("div", [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    kid.kidsName
                                                                  ) +
                                                                  " - " +
                                                                  _vm._s(
                                                                    _vm.parseKidStatusVietnamese(
                                                                      kid.statusKids
                                                                    )
                                                                  ) +
                                                                  "( " +
                                                                  _vm._s(
                                                                    kid.className
                                                                  ) +
                                                                  " )\n                              "
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 12 } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class: !_vm.isShowButtonScope
                                                    .employee
                                                    ? "element_apply disabled_apply"
                                                    : "element_apply",
                                                },
                                                [
                                                  _c(
                                                    "h4",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Danh sách nhân sự"
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "answer_apply",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        _vm._l(
                                                          _vm.applyForm
                                                            .employees,
                                                          function (
                                                            employee,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "div",
                                                              {
                                                                key: index,
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "12px",
                                                                  "margin-bottom":
                                                                    "8px",
                                                                  display:
                                                                    "flex",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-right":
                                                                          "4px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-circle-check",
                                                                      staticStyle:
                                                                        {
                                                                          color:
                                                                            "#67C23A",
                                                                        },
                                                                    }),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                  " +
                                                                        _vm._s(
                                                                          employee.teacherName
                                                                        ) +
                                                                        " (\n                                  "
                                                                    ),
                                                                    _vm._l(
                                                                      employee.departmentTeacherApplyList,
                                                                      function (
                                                                        department,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key: index,
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                    " +
                                                                                _vm._s(
                                                                                  department.departmentName
                                                                                ) +
                                                                                "\n                                    "
                                                                            ),
                                                                            index !==
                                                                            employee
                                                                              .departmentTeacherApplyList
                                                                              .length -
                                                                              1
                                                                              ? _c(
                                                                                  "span",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                      -\n                                    "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    _vm._v(
                                                                      "\n                                  )\n                                "
                                                                    ),
                                                                  ],
                                                                  2
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wrap_setting border_element_setting gutter_row",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "container_setting" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: !_vm.isAnswer
                                            ? "label_settings"
                                            : "disable_click",
                                        },
                                        [_vm._v("Cho phép sửa trả lời: ")]
                                      ),
                                      _c(
                                        "el-radio-group",
                                        {
                                          staticClass: "radio_options",
                                          attrs: { disabled: _vm.isAnswer },
                                          model: {
                                            value: _vm.defaultDataForm.fix,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.defaultDataForm,
                                                "fix",
                                                $$v
                                              )
                                            },
                                            expression: "defaultDataForm.fix",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: true } },
                                            [_vm._v("Có")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: false } },
                                            [_vm._v("Không")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _c("el-col", { attrs: { span: 14 } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wrap_setting border_element_setting gutter_row",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "container_setting" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: !_vm.isAnswer
                                            ? "label_settings"
                                            : "disable_click",
                                          on: {
                                            click: _vm.handleChangeAnonymous,
                                          },
                                        },
                                        [_vm._v("Cho phép trả lời ẩn danh")]
                                      ),
                                      _c("el-switch", {
                                        attrs: { disabled: _vm.isAnswer },
                                        model: {
                                          value: _vm.defaultDataForm.anonymous,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.defaultDataForm,
                                              "anonymous",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "defaultDataForm.anonymous",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "dialog-footer" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: { click: _vm.handleClose },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-circle-close",
                                }),
                                _vm._v(
                                  "\n                Hủy bỏ\n              "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function ($event) {
                                    !_vm.isAnswer
                                      ? _vm.handleSaveForm()
                                      : _vm.handleApply()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-circle-check",
                                }),
                                _vm._v("\n                Lưu\n              "),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 16 } }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.isLoadingCloneForm,
                            expression: "isLoadingCloneForm",
                          },
                        ],
                        staticClass: "wrap_survey_form",
                      },
                      [
                        _c("div", { staticClass: "survey_form" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                              },
                            },
                            [
                              _c("div", { staticClass: "form_wrap_custom" }, [
                                _c(
                                  "section",
                                  {
                                    staticClass:
                                      "wrap_image_form radius border",
                                  },
                                  [
                                    _c("el-image", {
                                      staticClass: "main_image",
                                      attrs: {
                                        src: _vm.defaultDataForm.imgWeb,
                                      },
                                    }),
                                    _c(
                                      "el-upload",
                                      {
                                        ref: "uploadImageSurveyForm",
                                        staticClass: "upload_image_form",
                                        class: {
                                          hideUpload:
                                            _vm.listImageForm.length > 0,
                                        },
                                        attrs: {
                                          action: "#",
                                          "list-type": "picture-card",
                                          "auto-upload": false,
                                          "file-list": "listImageForm",
                                          limit: 1,
                                          accept: "image/*",
                                          "show-file-list": true,
                                          "on-change": _vm.handleUploadImage,
                                          disabled: _vm.isAnswer,
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "file",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "container_image",
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "el-upload-list__item-thumbnail",
                                                      attrs: {
                                                        src: scope.file.url,
                                                        alt: "Ảnh",
                                                      },
                                                    }),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-upload-list__item-actions",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "el-upload-list__item-preview",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handlePictureCardPreview(
                                                                  scope.file
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-zoom-in",
                                                            }),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "el-upload-list__item-delete",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleRemoveImage(
                                                                  scope.file
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "el-icon-delete",
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-plus",
                                          style: {
                                            cursor: _vm.isAnswer
                                              ? "not-allowed"
                                              : "pointer",
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "section",
                                  {
                                    staticClass:
                                      "header_survey_form radius border element_form",
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("el-input", {
                                          class: [
                                            "header_survey_title",
                                            _vm.isValid.title
                                              ? "field_error"
                                              : "",
                                          ],
                                          attrs: {
                                            type: "text",
                                            placeholder:
                                              "Tiêu đề phiếu khảo sát",
                                            maxlength: 100,
                                            "show-word-limit": true,
                                            disabled: _vm.isAnswer,
                                          },
                                          on: {
                                            blur: function ($event) {
                                              return _vm.handleChangeInputHeader()
                                            },
                                          },
                                          model: {
                                            value: _vm.defaultDataForm.title,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.defaultDataForm,
                                                "title",
                                                $$v
                                              )
                                            },
                                            expression: "defaultDataForm.title",
                                          },
                                        }),
                                        _vm.isValid.title
                                          ? _c(
                                              "div",
                                              { staticClass: "message_error" },
                                              [
                                                _vm._v(
                                                  "*Vui lòng nhập tiêu để cho phiếu"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c("el-input", {
                                      staticClass: "header_survey_description",
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "Mô tả phiếu khảo sát",
                                        maxlength: 500,
                                        "show-word-limit": true,
                                        autosize: { minRows: 3, maxRows: 6 },
                                        rows: 3,
                                        disabled: _vm.isAnswer,
                                      },
                                      model: {
                                        value: _vm.defaultDataForm.description,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.defaultDataForm,
                                            "description",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "defaultDataForm.description",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "section",
                                  {
                                    ref: "wrapQuestion",
                                    staticClass: "wrap_question",
                                  },
                                  [
                                    _vm._l(
                                      _vm.defaultDataForm.questionResponseList,
                                      function (question, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            ref: `elementForm-${index}`,
                                            refInFor: true,
                                            staticClass:
                                              "radius border element_form",
                                            on: {
                                              click: function ($event) {
                                                !_vm.isAnswer &&
                                                  _vm.handleElementClick(index)
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "element_body" },
                                              [
                                                _c(
                                                  "el-row",
                                                  {
                                                    attrs: {
                                                      type: "flex",
                                                      gutter: 14,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 14 } },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "element_question",
                                                          },
                                                          [
                                                            _c("el-input", {
                                                              attrs: {
                                                                type: "text",
                                                                placeholder:
                                                                  "Câu hỏi",
                                                                maxlength: 1000,
                                                                "show-word-limit": true,
                                                                disabled:
                                                                  _vm.isAnswer,
                                                              },
                                                              on: {
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.handleChangeTitleQuestion(
                                                                    index
                                                                  )
                                                                },
                                                              },
                                                              model: {
                                                                value:
                                                                  question.questionText,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      question,
                                                                      "questionText",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "question.questionText",
                                                              },
                                                            }),
                                                            question.typeQuestion ===
                                                            "Text"
                                                              ? _c("el-input", {
                                                                  attrs: {
                                                                    type: "textarea",
                                                                    placeholder:
                                                                      "Văn bản trả lời",
                                                                    maxlength: 500,
                                                                    "show-word-limit": true,
                                                                    rows: 3,
                                                                    disabled: true,
                                                                    autosize: {
                                                                      minRows: 3,
                                                                      maxRows: 6,
                                                                    },
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            question.typeQuestion ===
                                                            "CheckBox"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "wrap_checkbox",
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      question.valueQuestionArray,
                                                                      function (
                                                                        item,
                                                                        indexOption
                                                                      ) {
                                                                        return _c(
                                                                          "el-checkbox",
                                                                          {
                                                                            key: indexOption,
                                                                            staticClass:
                                                                              "container_checkbox",
                                                                            attrs:
                                                                              {
                                                                                disabled: true,
                                                                                label:
                                                                                  item.value,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "inline-block",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "el-input",
                                                                                  {
                                                                                    staticClass:
                                                                                      "checkbox_options",
                                                                                    staticStyle:
                                                                                      {
                                                                                        width:
                                                                                          "100%",
                                                                                      },
                                                                                    attrs:
                                                                                      {
                                                                                        type: "text",
                                                                                        placeholder:
                                                                                          "Tuỳ chọn",
                                                                                        maxlength: 100,
                                                                                        "show-word-limit": true,
                                                                                        disabled:
                                                                                          _vm.isAnswer,
                                                                                      },
                                                                                    on: {
                                                                                      blur: function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleChangeValueQuestion(
                                                                                          index,
                                                                                          indexOption
                                                                                        )
                                                                                      },
                                                                                    },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          item.value,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              item,
                                                                                              "value",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "item.value",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                            question
                                                                              .valueQuestionArray
                                                                              .length >
                                                                              1 &&
                                                                            !_vm.isAnswer
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        display:
                                                                                          "inline-block",
                                                                                        "margin-left":
                                                                                          "30px",
                                                                                        "font-size":
                                                                                          "16px",
                                                                                        color:
                                                                                          "#000",
                                                                                        cursor:
                                                                                          "pointer",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-close",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleRemoveOptions(
                                                                                                question.valueQuestionArray,
                                                                                                index
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    [
                                                                      !_vm.isAnswer
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "add_option",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.handleFocusAddOptions(
                                                                                      question.valueQuestionArray,
                                                                                      `inputAddOptions-${index}`
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "el-icon-circle-plus",
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-weight":
                                                                                        "900",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Thêm"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                  ],
                                                                  2
                                                                )
                                                              : _vm._e(),
                                                            question.typeQuestion ===
                                                            "Radio"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "wrap_checkbox",
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      question.valueQuestionArray,
                                                                      function (
                                                                        item,
                                                                        indexOption
                                                                      ) {
                                                                        return _c(
                                                                          "el-radio",
                                                                          {
                                                                            key: indexOption,
                                                                            staticClass:
                                                                              "container_checkbox",
                                                                            attrs:
                                                                              {
                                                                                disabled: true,
                                                                                label:
                                                                                  item.value,
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "inline-block",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "el-input",
                                                                                  {
                                                                                    staticClass:
                                                                                      "checkbox_options",
                                                                                    staticStyle:
                                                                                      {
                                                                                        width:
                                                                                          "100%",
                                                                                      },
                                                                                    attrs:
                                                                                      {
                                                                                        type: "text",
                                                                                        placeholder:
                                                                                          "Tuỳ chọn",
                                                                                        maxlength: 100,
                                                                                        "show-word-limit": true,
                                                                                        disabled:
                                                                                          _vm.isAnswer,
                                                                                      },
                                                                                    on: {
                                                                                      blur: function (
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.handleChangeValueQuestion(
                                                                                          index,
                                                                                          indexOption
                                                                                        )
                                                                                      },
                                                                                    },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          item.value,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              item,
                                                                                              "value",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "item.value",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                            question
                                                                              .valueQuestionArray
                                                                              .length >
                                                                              1 &&
                                                                            !_vm.isAnswer
                                                                              ? _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        display:
                                                                                          "inline-block",
                                                                                        "margin-left":
                                                                                          "30px",
                                                                                        "font-size":
                                                                                          "16px",
                                                                                        color:
                                                                                          "#000",
                                                                                        cursor:
                                                                                          "pointer",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "i",
                                                                                      {
                                                                                        staticClass:
                                                                                          "el-icon-close",
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.handleRemoveOptions(
                                                                                                question.valueQuestionArray,
                                                                                                index
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              : _vm._e(),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    [
                                                                      !_vm.isAnswer
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "add_option",
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.handleFocusAddOptions(
                                                                                      question.valueQuestionArray,
                                                                                      `inputAddOptions-${index}`
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "i",
                                                                                {
                                                                                  staticClass:
                                                                                    "el-icon-circle-plus",
                                                                                }
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticStyle:
                                                                                    {
                                                                                      "font-weight":
                                                                                        "900",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Thêm"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                  ],
                                                                  2
                                                                )
                                                              : _vm._e(),
                                                            question.typeQuestion ===
                                                            "Point"
                                                              ? _c("div", [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                          "padding-left":
                                                                            "18px",
                                                                          gap: "0 14px",
                                                                        },
                                                                    },
                                                                    _vm._l(
                                                                      10,
                                                                      function (
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: index,
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    display:
                                                                                      "flex",
                                                                                    "justify-content":
                                                                                      "center",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "option_point",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                        " +
                                                                                        _vm._s(
                                                                                          item
                                                                                        ) +
                                                                                        "\n                                      "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            question.typeQuestion ===
                                                            "Star"
                                                              ? _c("div", [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                          gap: "0 10px",
                                                                          "padding-left":
                                                                            "18px",
                                                                        },
                                                                    },
                                                                    _vm._l(
                                                                      5,
                                                                      function (
                                                                        item
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          {
                                                                            key: item,
                                                                            staticClass:
                                                                              "icon_star",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "el-icon-star-off",
                                                                              }
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 10 } },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              display: "flex",
                                                              "justify-content":
                                                                "end",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticStyle: {
                                                                  width:
                                                                    "220px",
                                                                },
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.isAnswer,
                                                                },
                                                                on: {
                                                                  change: (
                                                                    value
                                                                  ) =>
                                                                    _vm.handleChangeTypeQuestion(
                                                                      question,
                                                                      value
                                                                    ),
                                                                  focus:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleElementClick(
                                                                        index
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    question.typeQuestion,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        question,
                                                                        "typeQuestion",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "question.typeQuestion",
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.typeQuestionOptions,
                                                                function (
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "el-option",
                                                                    {
                                                                      key: index,
                                                                      attrs: {
                                                                        label:
                                                                          item.label,
                                                                        value:
                                                                          item.value,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              display:
                                                                                "flex",
                                                                              gap: "0 20px",
                                                                              height:
                                                                                "100%",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  display:
                                                                                    "flex",
                                                                                  padding:
                                                                                    "5px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "el-image",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      src: item.icon,
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  "font-weight":
                                                                                    "600",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  item.label
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "element_footer" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      cursor: !_vm.isAnswer
                                                        ? "pointer"
                                                        : "not-allowed",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        !_vm.isAnswer &&
                                                          _vm.handleCloneQuestion(
                                                            index
                                                          )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-copy-document",
                                                    }),
                                                  ]
                                                ),
                                                _vm.defaultDataForm
                                                  .questionResponseList.length >
                                                1
                                                  ? _c(
                                                      "span",
                                                      {
                                                        style: {
                                                          cursor: !_vm.isAnswer
                                                            ? "pointer"
                                                            : "not-allowed",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            !_vm.isAnswer &&
                                                              _vm.handleRemoveQuestion(
                                                                index
                                                              )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-delete",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "wrap_require",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "label_require",
                                                      },
                                                      [_vm._v("Bắt buộc")]
                                                    ),
                                                    _c("el-switch", {
                                                      attrs: {
                                                        disabled: _vm.isAnswer,
                                                      },
                                                      model: {
                                                        value:
                                                          question.obligatory,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            question,
                                                            "obligatory",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "question.obligatory",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm.defaultDataForm.questionResponseList
                                      .length > 0
                                      ? _c(
                                          "div",
                                          {
                                            ref: "scrollTasks",
                                            staticClass: "scroll_tasks",
                                          },
                                          [
                                            !_vm.isAnswer
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: { placement: "top" },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          slot: "content",
                                                        },
                                                        slot: "content",
                                                      },
                                                      [_vm._v("Thêm câu hỏi")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "btn_scroll_tasks",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            !_vm.isAnswer &&
                                                              _vm.handleAddNewQuestion(
                                                                _vm.currentQuestionIndex
                                                              )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-plus-outline",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "btn_scroll_tasks",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          !_vm.isAnswer &&
                                                            _vm.handleAddNewQuestion(
                                                              _vm.currentQuestionIndex
                                                            )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-circle-plus-outline",
                                                      }),
                                                    ]
                                                  ),
                                                ]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                                _c("section", [
                                  _c(
                                    "div",
                                    { staticClass: "wrap_button_tasks" },
                                    [
                                      !_vm.isAnswer
                                        ? _c(
                                            "el-tooltip",
                                            { attrs: { placement: "top" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content",
                                                },
                                                [_vm._v("Thêm câu hỏi")]
                                              ),
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { circle: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      !_vm.isAnswer &&
                                                        _vm.handleAddNewQuestion(
                                                          _vm.defaultDataForm
                                                            .questionResponseList
                                                            .length - 1
                                                        )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _c(
                                            "div",
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: { circle: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      !_vm.isAnswer &&
                                                        _vm.handleAddNewQuestion(
                                                          _vm.defaultDataForm
                                                            .questionResponseList
                                                            .length - 1
                                                        )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "el-icon-plus",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog_image",
          attrs: {
            top: "40px",
            width: "30%",
            visible: _vm.isDialog.dialogVisibleImage,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.isDialog, "dialogVisibleImage", $event)
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              src: _vm.isDialog.dialogImageUrl,
              alt: "Ảnh phiếu",
            },
          }),
        ]
      ),
      _c("ApplyKidSurveyForm", {
        ref: "applyKidSurveyForm",
        attrs: { "is-open": _vm.isDialogApply.kid },
        on: {
          closeDialog: _vm.handleCloseDialogApplyKid,
          confirmData: _vm.handleConfirmKidsApply,
        },
      }),
      _c("ApplyEmployeeSurveyForm", {
        ref: "applyEmployeeSurveyForm",
        attrs: { "is-open": _vm.isDialogApply.employee },
        on: {
          closeDialog: _vm.handleCloseDialogApplyEmployee,
          confirmData: _vm.handleConfirmEmployeesApply,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }